import * as BundleTypes from 'self-service-api/constants/BundleTypes';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
import { NavItemEnum } from '../routing/NavItems';
import { ENTERPRISE, STARTER } from '../routing/Tabs';
const tabIdToMerchCardLevelMap = {
  [STARTER]: [ProductLevels.FREE, ProductLevels.STARTER, ProductLevels.PROFESSIONAL],
  [ENTERPRISE]: [ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE]
};
export const getMerchCardsToShowSSM0009 = ({
  navItem
}) => {
  if (navItem === NavItemEnum.FREE) {
    return [ProductLevels.FREE, ProductLevels.STARTER];
  }
  if (navItem === NavItemEnum.SUITE) {
    return [ProductLevels.FREE, ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
  }
  return ProductLevels.currentOrderedPaidProductLevels;
};
export const getMerchCardsToShow = ({
  tab,
  isFreeToStarter
}) => {
  if (isFreeToStarter) {
    return [ProductLevels.FREE, ProductLevels.STARTER];
  }
  return tab ? tabIdToMerchCardLevelMap[tab] : ProductLevels.currentOrderedPaidProductLevels;
};
export const getMerchCardsToShowProEnterpriseOnly = () => {
  return [ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
};
export const getMerchCardsToShowPaid = () => {
  return ProductLevels.currentOrderedPaidProductLevels;
};
export const getMerchCardsToShowAll = () => {
  return ProductLevels.currentOrderedProductLevels;
};
export const getMobileMerchCardsToShow = bundleType => {
  switch (bundleType) {
    case BundleTypes.NONE:
      return [];
    case BundleTypes.CRM_SUITE:
    default:
      {
        return [ProductLevels.FREE, ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
      }
  }
};
export const getMerchCardsToShowForBundle = ({
  bundleType,
  tab
}) => {
  switch (bundleType) {
    case BundleTypes.CRM_SUITE:
      {
        return tab ? tabIdToMerchCardLevelMap[tab] : ProductLevels.currentOrderedPaidProductLevels;
      }
    case BundleTypes.NONE:
    default:
      {
        return [];
      }
  }
};